import { GraphQLClient } from "graphql-request";

/**
 * Same-origin in both environments: in dev Vite proxies /graphql to the API on
 * :3000, and in production nginx routes it to the server pod. Either way the
 * request never crosses an origin, so better-auth's cookies just work.
 *
 * graphql-request requires an *absolute* URL (it constructs `new URL(...)`
 * internally), hence resolving against window.location.origin rather than
 * passing a bare "/graphql".
 */
export const gqlClient = new GraphQLClient(
  new URL("/graphql", window.location.origin).toString(),
  { credentials: "include" },
);
